import ScrollReveal from 'scrollreveal'
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // default configuration for scrollreveal
    // desktop animations config
      var desktop = {
        mobile: false,
        distance: '3%',
        duration: 800,
        viewFactor: 0.2,
        delay: 50,
        origin: 'bottom',
      }
      ScrollReveal(desktop);


      ScrollReveal().reveal('.panel-row:nth-of-type(even) .panel-content, .testimonials-col', {
        origin: 'left',
      });

      ScrollReveal().reveal('.panel-row.static .panel-content, .panel-row:nth-of-type(odd) .panel-content', {
        origin: 'right',
      });

      ScrollReveal().reveal('.hero-content, .prefooter-content');
  },
};
